/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './medication-schedule.reducer';

export const MedicationScheduleDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const medicationScheduleEntity = useAppSelector(state => state.medicationSchedule.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="medicationScheduleDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.medicationSchedule.detail.title">MedicationSchedule</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.medicationSchedule.id">Id</Translate>
            </span>
          </dt>
          <dd>{medicationScheduleEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.medicationSchedule.name">Name</Translate>
            </span>
          </dt>
          <dd>{medicationScheduleEntity.name}</dd>
          <dt>
            <span id="tmValue">
              <Translate contentKey="tinyMedicRestApp.medicationSchedule.tmValue">Tm Value</Translate>
            </span>
          </dt>
          <dd>{medicationScheduleEntity.tmValue}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.medicationSchedule.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{medicationScheduleEntity.timestampentry}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.medicationSchedule.active">Active</Translate>
            </span>
          </dt>
          <dd>{medicationScheduleEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.medicationSchedule.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{medicationScheduleEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.medicationSchedule.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{medicationScheduleEntity.cursor}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.medicationSchedule.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{medicationScheduleEntity.microSec}</dd>
          <dt>
            <span id="shortCode">
              <Translate contentKey="tinyMedicRestApp.medicationSchedule.shortCode">Short Code</Translate>
            </span>
          </dt>
          <dd>{medicationScheduleEntity.shortCode}</dd>
          <dt>
            <span id="lang">
              <Translate contentKey="tinyMedicRestApp.medicationSchedule.lang">Lang</Translate>
            </span>
          </dt>
          <dd>{medicationScheduleEntity.lang}</dd>
          <dt>
            <span id="sortOrder">
              <Translate contentKey="tinyMedicRestApp.medicationSchedule.sortOrder">Sort Order</Translate>
            </span>
          </dt>
          <dd>{medicationScheduleEntity.sortOrder}</dd>
        </dl>
        <Button tag={Link} to="/medication-schedule" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/medication-schedule/${medicationScheduleEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MedicationScheduleDetail;
